import React from "react"
import { Navigate } from "react-router-dom"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import Configs from "../config"
import VerifyCode from "pages/Authentication/VerifyOTP"
import ResetPassword from "pages/Authentication/ResetPassword"
import AuditLogs from "pages/AuditLogs"
import RolesIndex from "pages/Roles"
import StaffIndex from "pages/Staff"
import VendorIndex from "pages/Vendor"
import DocumentIndex from "pages/Document"
import ProductIndex from "pages/Products"
import Notifications from "pages/Notifications"
import POSSheetNames from "pages/Settings/POSSheet"
import DepartmentManagement from "pages/Settings/Department"
import Category from "pages/Settings/Category"
import ClassName from "pages/Settings/className"
import ProgramBuilds from "pages/Settings/programBuilds"
import StoneIndex from "pages/Settings/StoneIndex"
import UploadIndex from "pages/Document/upload"
import Brand from "pages/Settings/Brand"
import StoreIndex from "pages/Settings/Store"
import VMCodeOne from "pages/Settings/VMCodeOne"
import VMCodeFive from "pages/Settings/VMCodeFive"
import VMCodeSix from "pages/Settings/VMCodeSix"
import VMCodeSeven from "pages/Settings/VMCodeSeven"
import VMCodeEight from "pages/Settings/VMCodeEight"
import ComponentTypeOne from "pages/Settings/ComponentTypeOne"
import PromotionCode from "pages/Settings/PromotionCode"

const authProtectedRoutes = [
  { path: `${Configs.appurl}dashboard`, component: <Dashboard /> },

  // Audit Logs
  { path: `${Configs.appurl}audit-logs`, component: <AuditLogs /> },

  // Roles
  { path: `${Configs.appurl}roles`, component: <RolesIndex /> },

  // Staff
  { path: `${Configs.appurl}staff`, component: <StaffIndex /> },

  // Vendor
  { path: `${Configs.appurl}vendor`, component: <VendorIndex /> },

  // Document
  { path: `${Configs.appurl}import-invoice`, component: <UploadIndex /> },
  { path: `${Configs.appurl}inventory`, component: <DocumentIndex /> },

  // Product
  { path: `${Configs.appurl}product`, component: <ProductIndex /> },

  // Notifcations
  { path: `${Configs.appurl}notifications`, component: <Notifications /> },

  // pos-names
  { path: `${Configs.appurl}pos-names`, component: <POSSheetNames /> },

  // DepartmentManagement
  { path: `${Configs.appurl}departments`, component: <DepartmentManagement /> },

  // Category
  { path: `${Configs.appurl}category`, component: <Category /> },

  // classnames
  { path: `${Configs.appurl}classnames`, component: <ClassName /> },

  // programs
  { path: `${Configs.appurl}programs`, component: <ProgramBuilds /> },

  // Stone
  { path: `${Configs.appurl}stone`, component: <StoneIndex /> },
  // Stone
  { path: `${Configs.appurl}brand`, component: <Brand /> },
  // Store
  { path: `${Configs.appurl}store`, component: <StoreIndex /> },

  // VM Code
  { path: `${Configs.appurl}vm-code-one`, component: <VMCodeOne /> },
  { path: `${Configs.appurl}vm-code-five`, component: <VMCodeFive /> },
  { path: `${Configs.appurl}vm-code-six`, component: <VMCodeSix /> },
  { path: `${Configs.appurl}vm-code-seven`, component: <VMCodeSeven /> },
  { path: `${Configs.appurl}vm-code-eight`, component: <VMCodeEight /> },
  { path: `${Configs.appurl}component-type-one`, component: <ComponentTypeOne /> },
  { path: `${Configs.appurl}promotion-code`, component: <PromotionCode /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: `${Configs.appurl}`,
    exact: true,
    component: <Navigate to="dashboard" />,
  },
]

const publicRoutes = [
  { path: `${Configs.appurl}logout`, component: <Logout /> },
  { path: `${Configs.appurl}login`, component: <Login /> },
  { path: `${Configs.appurl}forgot-password`, component: <ForgetPwd /> },
  { path: `${Configs.appurl}verify-code`, component: <VerifyCode /> },
  { path: `${Configs.appurl}reset-password`, component: <ResetPassword /> },
]

export { authProtectedRoutes, publicRoutes }
